<div class="info-content" dir="rtl">
  <div class="info-card">
    <div class="widget">
      <div class="section-header">
        <h5 class="heading-design-h5">
          {{ this.translate.instant('sale4you.label.MyProfile') }}
        </h5>
      </div>

      <!-- Top row: profile photo + coupon activation side by side (stacked on narrow screens). -->
      <div class="profile-top">
        <section class="profile-photo-editor" dir="rtl" aria-labelledby="profile-photo-title">
          <app-images-box
            [selectClass]="'personal-area'"
            [imageSelected]="userInfo.avatar"
            (onChange)="onAvatarChange($event)">
          </app-images-box>
          <div class="profile-photo-editor__copy">
            <h6 id="profile-photo-title">תמונת פרופיל</h6>
            <p>התמונה תוצג בפרופיל המוכר ולצד המודעות שלך.</p>
            <small>מומלץ להעלות תמונה מרובעת וברורה. JPG או PNG.</small>
          </div>
        </section>

        <!-- SCRUM-311 + 328: activate a coupon code (hidden when the server turns redemption off) -->
        <div class="coupon-activation-slot">
          <app-coupon-activation></app-coupon-activation>
        </div>
      </div>

      <form>

        <!-- Row 1: First / Last Name -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                <span class="required">*</span>
                {{ this.translate.instant('sale4you.label.MyProfile.FirstName') }}
              </label>
              <input class="form-control" [(ngModel)]="userInfo.first_name"
                name="first_name" placeholder="שם פרטי" type="text">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                <span class="required">*</span>
                {{ this.translate.instant('sale4you.label.MyProfile.LastName') }}
              </label>
              <input class="form-control" [(ngModel)]="userInfo.last_name"
                name="last_name" placeholder="שם משפחה" type="text">
            </div>
          </div>
        </div>

        <!-- Row 2: Email / Secondary Phone -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                <span class="required">*</span>
                {{ this.translate.instant('sale4you.label.MyProfile.Email') }}
              </label>
              <!-- The account email is a fixed identity key; only support changes it. -->
              <input class="form-control" [ngModel]="userInfo.email"
                name="email" type="email" placeholder="דוא&quot;ל" readonly
                style="background:#f1f4f8;color:#475467;cursor:not-allowed" dir="ltr">
              <small style="display:block;margin-top:4px;color:#667085;font-size:12px">
                לא ניתן לשנות את כתובת האימייל. לשינוי יש לפנות לתמיכה.
              </small>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.SecondaryPhone') }}
              </label>
              <input class="form-control" [(ngModel)]="userInfo.scondryPhone"
                name="scondryPhone" type="text" placeholder="טלפון משני (אופציונלי)">
            </div>
          </div>
        </div>

        <!-- Row 3: Main Phone / Gender -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                <span class="required">*</span>
                {{ this.translate.instant('sale4you.label.MyProfile.PhoneNumber') }}
              </label>
              <app-phone-verify
                [phone]="userInfo.mainPhone"
                [email]="userInfo.email"
                [contactPerson]="userInfo.first_name + ' ' + userInfo.last_name"
                (phoneChanged)="userInfo.mainPhone = $event"
                (editModeChange)="phoneEditPending = $event">
              </app-phone-verify>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.Gender') }}
              </label>
              <select [attr.aria-label]="translate.instant('sale4you.label.MyProfile.Gender')" class="form-control" [(ngModel)]="userInfo.gender" name="gender">
                <option value="">-- בחר מגדר --</option>
                @for (g of genderOptions; track g) {
                  <option [value]="g.value">{{ g.label }}</option>
                }
              </select>
            </div>
          </div>
        </div>

        <!-- Row 4: Birthday -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.Birthday') }}
              </label>
              <input [attr.aria-label]="translate.instant('sale4you.label.MyProfile.Birthday')" class="form-control"
                [ngModel]="userInfo.birthday | date:'yyyy-MM-dd'"
                (ngModelChange)="userInfo.birthday = $event"
                type="date" name="birthday">
            </div>
          </div>
          <!-- ID number field removed 2026-10-30 (SEC-23: not needed, no longer stored) -->
        </div>

        <!-- Row 5: ID Expiry / Family Status -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.IdExDate') }}
              </label>
              <input [attr.aria-label]="translate.instant('sale4you.label.MyProfile.IdExDate')" class="form-control"
                [ngModel]="userInfo.idExDate | date:'yyyy-MM-dd'"
                (ngModelChange)="userInfo.idExDate = $event"
                type="date" name="idExDate">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.FamilyStatus') }}
              </label>
              <select [attr.aria-label]="translate.instant('sale4you.label.MyProfile.FamilyStatus')" class="form-control" [(ngModel)]="userInfo.FamilyStatus" name="FamilyStatus">
                <option value="">-- בחר מצב משפחתי --</option>
                @for (s of familyStatusOptions; track s) {
                  <option [value]="s">{{ s }}</option>
                }
              </select>
            </div>
          </div>
        </div>

        <!-- Row 6: Country / Area -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.Country') }}
              </label>
              <input [attr.aria-label]="translate.instant('sale4you.label.MyProfile.Country')" class="form-control" [(ngModel)]="userInfo.country"
                name="country" type="text">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.Area') }}
              </label>
              <div class="dd-wrapper">
                <input class="form-control"
                  [(ngModel)]="areaInput"
                  name="areaInput"
                  (input)="onAreaInput($event.target.value)"
                  (focus)="showAreaDropdown = true"
                  (blur)="hideDropdown('area')"
                  placeholder="חפש אזור..."
                  autocomplete="off">
                @if (loadingAreas) {
                  <span class="dd-spinner">
                    <i class="mdi mdi-loading mdi-spin"></i>
                  </span>
                }
                @if (showAreaDropdown && filteredAreas.length > 0) {
                  <ul class="dd-list">
                    @for (a of filteredAreas; track a) {
                      <li
                      (mousedown)="onAreaSelect(a)">{{ a.label }}</li>
                    }
                  </ul>
                }
              </div>
            </div>
          </div>
        </div>

        <!-- Row 7: City / Neighborhood -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                <span class="required">*</span>
                {{ this.translate.instant('sale4you.label.MyProfile.City') }}
              </label>
              <div class="dd-wrapper">
                <input class="form-control"
                  [(ngModel)]="cityInput"
                  name="cityInput"
                  (input)="onCityInput($event.target.value)"
                  (focus)="showCityDropdown = true"
                  (blur)="hideDropdown('city')"
                  placeholder="חפש עיר..."
                  autocomplete="off">
                @if (loadingCities) {
                  <span class="dd-spinner">
                    <i class="mdi mdi-loading mdi-spin"></i>
                  </span>
                }
                @if (showCityDropdown && filteredCities.length > 0) {
                  <ul class="dd-list">
                    @for (c of filteredCities; track c) {
                      <li
                      (mousedown)="onCitySelect(c)">{{ c.label }}</li>
                    }
                  </ul>
                }
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.Neighborhood') }}
              </label>
              <div class="dd-wrapper">
                <input class="form-control"
                  [(ngModel)]="neighborhoodInput"
                  name="neighborhoodInput"
                  (input)="onNeighborhoodInput($event.target.value)"
                  (focus)="showNeighborhoodDropdown = true"
                  (blur)="hideDropdown('neighborhood')"
                  placeholder="חפש שכונה..."
                  autocomplete="off">
                @if (loadingNeighborhoods) {
                  <span class="dd-spinner">
                    <i class="mdi mdi-loading mdi-spin"></i>
                  </span>
                }
                @if (showNeighborhoodDropdown && filteredNeighborhoods.length > 0) {
                  <ul class="dd-list">
                    @for (n of filteredNeighborhoods; track n) {
                      <li
                      (mousedown)="onNeighborhoodSelect(n)">{{ n.label }}</li>
                    }
                  </ul>
                }
              </div>
            </div>
          </div>
        </div>

        <!-- Row 8: Street / Street Number -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.Street') }}
              </label>
              <div class="dd-wrapper">
                <input class="form-control"
                  [(ngModel)]="streetInput"
                  name="streetInput"
                  (input)="onStreetInput($event.target.value)"
                  (focus)="showStreetDropdown = true"
                  (blur)="hideDropdown('street')"
                  [placeholder]="userInfo.city ? 'חפש רחוב...' : 'בחר עיר תחילה'"
                  [disabled]="!userInfo.city"
                  autocomplete="off">
                @if (loadingStreets) {
                  <span class="dd-spinner">
                    <i class="mdi mdi-loading mdi-spin"></i>
                  </span>
                }
                @if (showStreetDropdown && filteredStreets.length > 0) {
                  <ul class="dd-list">
                    @for (s of filteredStreets; track s) {
                      <li
                      (mousedown)="onStreetSelect(s)">{{ s.label }}</li>
                    }
                  </ul>
                }
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.StreetNumber') }}
              </label>
              <input [attr.aria-label]="translate.instant('sale4you.label.MyProfile.StreetNumber')" class="form-control" [(ngModel)]="userInfo.streetNumber"
                name="streetNumber" type="number">
            </div>
          </div>
        </div>

        <!-- Row 9: Department / Zip Code -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.Department') }}
              </label>
              <input [attr.aria-label]="translate.instant('sale4you.label.MyProfile.Department')" class="form-control" [(ngModel)]="userInfo.department"
                name="department" type="number">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.ZipCode') }}
              </label>
              <input [attr.aria-label]="translate.instant('sale4you.label.MyProfile.ZipCode')" class="form-control" [(ngModel)]="userInfo.zipCode"
                name="zipCode" type="number">
            </div>
          </div>
        </div>

        <!-- Row 10: PO Box / Date Joined -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.PoBox') }}
              </label>
              <input [attr.aria-label]="translate.instant('sale4you.label.MyProfile.PoBox')" class="form-control" [(ngModel)]="userInfo.PoBox"
                name="PoBox" type="number">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label">
                {{ this.translate.instant('sale4you.label.MyProfile.DateJoined') }}
              </label>
              <input [attr.aria-label]="translate.instant('sale4you.label.MyProfile.DateJoined')" class="form-control"
                [ngModel]="userInfo.date_joined | date:'yyyy-MM-dd'"
                type="date" name="date_joined" readonly>
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="row">
          <div class="col-sm-12 text-right">
            <button type="button" class="btn btn-danger" (click)="loadData()">
              {{ this.translate.instant('sale4you.label.MyProfile.Cancelation') }}
            </button>
            <button type="button" (click)="saveUserInfo()"
              class="btn btn-success"
              [disabled]="phoneEditPending"
              [title]="phoneEditPending ? 'יש לאמת את מספר הטלפון לפני השמירה' : ''">
              @if (phoneEditPending) {
                <i class="mdi mdi-lock-outline"></i>
              }
              {{ this.translate.instant('sale4you.label.MyProfile.SavingChanges') }}
            </button>
          </div>
        </div>

      </form>

      <!-- SCRUM-124: terms approval with the ORIGINAL date/time, archive and marketing consent -->
      <section class="consent-panel" aria-labelledby="consent-title">
        <h6 id="consent-title" class="consent-panel__title">תקנון והסכמות</h6>

        @if (consent?.termsAcceptance; as current) {
          <p class="consent-panel__status consent-panel__status--ok">
            התקנון (גרסה {{ current.termsVersion }}) אושר בתאריך {{ current.acceptedDate }} בשעה {{ current.acceptedTime }}
          </p>
          <a routerLink="/terms" [queryParams]="{version: current.termsVersion}" class="consent-panel__link">לצפייה בגרסה שאישרת</a>
        } @else if (consent) {
          <p class="consent-panel__status consent-panel__status--pending">
            טרם אישרת את גרסת התקנון הנוכחית ({{ consent.currentTermsVersion }}).
          </p>
          <button type="button" class="btn btn-success consent-panel__btn" [disabled]="consentBusy" (click)="acceptTermsFromProfile()">
            קריאה ואישור התקנון
          </button>
        } @else {
          <p class="consent-panel__status">לא ניתן לטעון כרגע את פרטי אישור התקנון.</p>
        }
        @if (!consent?.termsAcceptance) {
          <a routerLink="/terms" class="consent-panel__link">לצפייה בנוסח התקנון</a>
        }

        @if (olderTermsAcceptances.length) {
          <details class="consent-panel__archive">
            <summary>ארכיון אישורי תקנון</summary>
            <ul>
              @for (item of olderTermsAcceptances; track item.termsVersion) {
                <li>
                  גרסה {{ item.termsVersion }} – אושרה בתאריך {{ item.acceptedDate }} בשעה {{ item.acceptedTime }}
                  · <a routerLink="/terms" [queryParams]="{version: item.termsVersion}">צפייה בגרסה</a>
                </li>
              }
            </ul>
          </details>
        }

        @if (consent) {
          <label class="consent-panel__toggle" [class.is-disabled]="!consent.acceptTerms && !consent.acceptAdv">
            <input type="checkbox"
                   [checked]="consent.acceptAdv"
                   [disabled]="consentBusy || (!consent.acceptTerms && !consent.acceptAdv)"
                   (change)="toggleMarketing($any($event.target).checked)">
            <span>אני רוצה לקבל עדכונים ודיוור שיווקי במייל (לא חובה, ניתן לבטל בכל עת)</span>
          </label>
          @if (!consent.acceptTerms && !consent.acceptAdv) {
            <small class="consent-panel__hint">יש לאשר את התקנון תחילה</small>
          }
        }
        @if (consentMessage) {
          <p class="consent-panel__status consent-panel__status--error" role="alert">{{ consentMessage }}</p>
        }
      </section>
      <!-- SEC-07 / SEC-08 (SCRUM-352, 353): download my data / delete account -->
      <app-privacy-controls></app-privacy-controls>
      <!-- SEC-08b (SCRUM-394): my privacy requests + timeline -->
      <app-privacy-requests></app-privacy-requests>
    </div>
  </div>
</div>
